import { render, staticRenderFns } from "./TracksNew.vue?vue&type=template&id=d2097c9e&lang=html&"
import script from "./TracksNew.vue?vue&type=script&lang=js&"
export * from "./TracksNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports